import { useState } from 'react';

import { Cookie } from '@catawiki/runtime-toolkit';

export function useMobileApp(overrideValue?: boolean) {
  const [mobileApp] = useState(
    overrideValue !== undefined ? overrideValue : Cookie.getIsMobileApp()
  );
  return mobileApp;
}
